import axios from 'axios'
import config from '@assets/config.json' // api 请求json

const state = {
  hostExhibition: null // 主办后台展会信息
}
const mutations = {
  setHostExhibition(state, data) {
    state.hostExhibition = data
  }
}
const getters = {
  getHostExhibition: (state) => {
    return state.hostExhibition
  },
  getHostExhibitionId: (state) => {
    return state.hostExhibition ? state.hostExhibition.id : ''
  }
}
const actions = {
  // 操作日志a
  applicationLogs({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ApplicationLogs/GetLogs`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getCompanyByJoin({ rootState }, opt) {
    // 通过agentId 获取展商
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/join/GetByManager`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getCompanyByJoinOne({ rootState }, id) {
    // 获取单个展商
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/company?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delCompanyById({ rootState }, id) {
    // 删除展商
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/company?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addCompany({ rootState }, opt) {
    // 新增公司
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/company`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  editCompanyInfo({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/company`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  setTopic({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/join/SetTopic`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  setPrizeLabel({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/join/setPrizeLabel`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  setBrandTopic({ rootState }, opt) {
    // 修改品牌推荐
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/join/SetBrandTopic`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  setToTop({ rootState }, opt) {
    // 修改展商置顶
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/join/SetTopping`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  editCompanyShow({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/join/SetIsShow`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  syncArrHandle({ rootState }, id) {
    // 批量同步”按钮，将当前展会中历届提交过会刊的展商批量重新提交会刊，自动审核
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/Catalogue/UpdateDownBatch?exhibitionId=${id}`,
          rootState.header
        )
        .then(({ data }) => {
          if (data) {
            resolve(data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  editCompany({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/join`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  RegisterAccount({ rootState }, opt) {
    // 添加用户
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.auth}/api/Account/Register`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  RegisterCompany({ rootState }, opt) {
    // 添加公司
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/company`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  RegisterJoin({ rootState }, opt) {
    // 添加参展
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/join`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  RegisterStaff({ rootState }, opt) {
    // 添加员工
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/staff`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getExhibitionById({ rootState }, id) {
    // 获取当前展会
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/exhibition?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  editExhibition({ rootState }, opt) {
    // 修改展会信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/exhibition`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  getPavilion({ rootState }, id) {
    // 获取展馆
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/exhall/GetByExhibition?exhibitionId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addPavilion({ rootState }, opt) {
    // 添加展馆
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/exhall`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delPavilionById({ rootState }, id) {
    // 删除展馆
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/exhall?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  editPavilion({ rootState }, opt) {
    // 修改展馆信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/exhall`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  getExByAgentId({ rootState }, opt) {
    // 通过agentId 获取展会
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/exhibition/GetByAgent`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addEx({ rootState }, opt) {
    // 添加展会
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/exhibition`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delExById({ rootState }, id) {
    // 删除展会
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/exhibition?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getBusinessTypeList({ rootState }, url) {
    // 获取企业经营类别 / 会刊 / 联系人 / 企业性质 / 产品适用渠道 / 产品应用科室
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}${url}`, rootState.header)
        .then((res) => {
          if (res.data && res.status) {
            resolve(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addBusType({ rootState }, opt) {
    // 添加企业经营类别 / 会刊 / 联系人 / 企业性质 / 产品适用渠道 / 产品应用科室
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}${opt.url}`, opt.req, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  putBusType({ rootState }, opt) {
    // 编辑企业经营类别 / 会刊 / 联系人 / 企业性质 / 产品适用渠道 / 产品应用科室
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}${opt.url}`, opt.req, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delBusType({ rootState }, opt) {
    // 删除企业经营类别 / 会刊 / 联系人 / 企业性质 / 产品适用渠道 / 产品应用科室
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}${opt.url}?id=${opt.id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getindTypeList({ rootState }, url) {
    // 获取行业类别
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}${url}`, rootState.header)
        .then((res) => {
          if (res.data && res.status) {
            resolve(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addindType({ rootState }, opt) {
    // 添加行业类别
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}${opt.url}`, opt.req, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  putindType({ rootState }, opt) {
    // 编辑行业类别
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}${opt.url}`, opt.req, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getActionType({ rootState }, id) {
    // 获取云台标签
    // 1=品牌商 - 授权渠道
    // 2=品牌商 -招募地区
    // 3=工厂 -  服务范围
    // 4=工厂 - 代工类型
    // 5=服务商 - 擅长领域
    // 6=服务商 - 服务地区
    // 7=加盟商 - 店铺类型
    // 8=加盟商 - 招募地区
    // 9=其他
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/actionType/GetList?typeId=${id}`,
          rootState.header
        )
        .then((res) => {
          if (res.data && res.status) {
            resolve(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addActionType({ rootState }, opt) {
    // 新增云台标签
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/actionType`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  putActionType({ rootState }, opt) {
    // 编辑云台标签
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/actionType`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delActionType({ rootState }, id) {
    // 删除云台标签
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/actionType?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getRegion({ rootState }) {
    // 获取招商区域内容
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/Region/GetListAndChildren`,
          rootState.header
        )
        .then((res) => {
          if (res.data && res.status) {
            resolve(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addRegion({ rootState }, opt) {
    // 新增招商区域
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/Region`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  putRegion({ rootState }, opt) {
    // 编辑招商区域
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/Region`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delRegion({ rootState }, id) {
    // 删除招商区域
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/Region?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  getCountry({ rootState }) {
    // 获取国家
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/Country/GetList`, rootState.header)
        .then((res) => {
          if (res.data && res.status) {
            resolve(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addCountry({ rootState }, opt) {
    // 新增国家
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/Country`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  putCountry({ rootState }, opt) {
    // 编辑国家
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/Country`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delCountry({ rootState }, id) {
    // 删除招商区域
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/Country?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  getCity({ rootState }) {
    // 获取省市
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/City/GetListAndChildren`,
          rootState.header
        )
        .then((res) => {
          if (res.data && res.status) {
            let data = res.data[0].list
            data.map((c) => {
              c.children = []
              c.type = 1
              c._loading = false
              c.list.map((d) => {
                d.children = []
                d.type = 1
                d._loading = false
              })
            })
            resolve(data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getCity2({ rootState }, id) {
    // 获取省市
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/city/GetByParentId?parentId=${id}`,
          rootState.header
        )
        .then((res) => {
          if (res.data && res.status) {
            res.data.map((c) => {
              if (c.leveltype == 1) {
                c.type = 1
              }
              if (c.leveltype == 2) {
                c.type = 2
              }
              if (c.leveltype == 1 || c.leveltype == 2) {
                c.children = []
                c._loading = false
                c._showChildren = false
              }
            })
            resolve(res.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  addCity({ rootState }, opt) {
    // 新增省市
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/City`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  putCity({ rootState }, opt) {
    // 编辑省市
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/City`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  delCity({ rootState }, id) {
    // 删除省市
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/City?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  editExPwd({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/UserInfo/SetPassword`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取车证
  getCaritem({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/Vehicle/GetPagedListByExhibitionId`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //导出车证
  getCarExcel({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/Vehicle/ExcelExport`, opt, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], {
              type: 'application/vnd.ms-excel'
            })
            aLink.href = URL.createObjectURL(blob)
            aLink.setAttribute('download', '车证信息' + '.xlsx') // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  getFile({ rootState }, key) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/file?key=${key}`, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], {
              type: 'application/pdf'
            })
            aLink.href = URL.createObjectURL(blob)
            aLink.setAttribute('download', '展商申请' + '.pdf') // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //获取展会下所有展团
  getPavilion({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/DeTerm/GetList?exhibitionId=${id}`,
          {},
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  //  ======================================================
  // 主办后台获取用户列表
  getHostUser({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/UserInfo/MemberList`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //   用户加入黑名单
  getHostUserJoinBlackList({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/UserInfo/UpUserBlackList?memId=${id}`,
          {},
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 主办后台获取 采买供需列表
  getHostBuySupply({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/CallingCard/getNewCallingCard`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 主办后台 采买供需列表  修改状态
  putHostUpdateState({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/CallingCard/updateCallingState`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  //   再次通知
  getHostCallingAgain({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/CallingCard/callingAgain?id=${id}`,
          {},
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  //导出 采买供需
  getBuyExport({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/CallingCard/ExcelExportBack`, opt, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], {
              type: 'application/vnd.ms-excel'
            })
            aLink.href = URL.createObjectURL(blob)
            if (opt.conditions.state == '0,2' && opt.hour24 == false) {
              aLink.setAttribute('download', '采买供需-已收回' + '.xlsx') // 设置下载文件名称
            }
            if (opt.conditions.state == '0,2' && opt.hour24 == true) {
              aLink.setAttribute('download', '采买供需-未接收/忽略' + '.xlsx') // 设置下载文件名称
            }
            if (opt.conditions.state == '1') {
              aLink.setAttribute('download', '采买供需-已接收' + '.xlsx') // 设置下载文件名称
            }
            if (opt.conditions.state == '3') {
              aLink.setAttribute('download', '采买供需-被拒绝' + '.xlsx') // 设置下载文件名称
            }
            // aLink.setAttribute("download", "采买供需" + ".xlsx"); // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  //
  // 商机供需
  //

  // 主办查询  /api/NewRealease/GetPageList
  busOppNewRealeaseGetPageList({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/NewRealease/GetPageList`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  ///api/NewRealease 单条数据查询
  busOppNewRealeaseGetIdInfo({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/NewRealease?id=${id}`,
          {},
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // /api/ReleaseRelevancy/getAllByReleaseId通过供需id获取所有绑定的数据
  busOppNewRealeaseGetAllByReleaseId({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/ReleaseRelevancy/getAllByReleaseId?releaseId=${id}`,
          {},
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  ////api/NewRealease  修改数据
  busOppNewRealeasePutUpdate({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/NewRealease`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // 商机供需   详情界面的接口
  // /api/ReleaseRelevancy  单条数据删除
  busOppReleaseRelevancyDetailDelete({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/ReleaseRelevancy?id=${id}`,
          {},
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // /api/ReleaseRelevancy 修改数据
  busOppReleaseRelevancyDetailPutUpdate({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/ReleaseRelevancy`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // /api/ReleaseRelevancy/listPush 批量推送
  busOppReleaseRelevancyDetailListPush({ rootState }, ids) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ReleaseRelevancy/listPush`,
          ids,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // /api/ReleaseRelevancy/listCancelPush 批量取消推送
  busOppReleaseRelevancyDetailListCancelPush({ rootState }, ids) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ReleaseRelevancy/listCancelPush`,
          ids,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // /api/Product/getByCategoryId   通过类别最后一级id 查询产品（供需使用）
  busOppProductGetByCategoryIdDetail({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/Product/getByCategoryId`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // /api/ReleaseRelevancy/listAdd  批量新增 绑定展商
  busOppProductlistAddDetail({ rootState }, lists) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/ReleaseRelevancy/listAdd`,
          lists,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  // /api/NewRealease/ExcelExportHost  主办商机导出
  busOppNewRealeaseExcelExportHost({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/NewRealease/ExcelExportHost`,
          opt.option,
          {
            responseType: 'arraybuffer',
            ...rootState.header
          }
        )
        .then((data) => {
          if (data.data) {
            const aLink = document.createElement('a')
            let blob = new Blob([data.data], {
              type: 'application/vnd.ms-excel'
            })
            aLink.href = URL.createObjectURL(blob)
            if (opt.index == '0') {
              aLink.setAttribute('download', '待推送' + '.xlsx') // 设置下载文件名称
            }
            if (opt.index == '1') {
              aLink.setAttribute('download', '已推送' + '.xlsx') // 设置下载文件名称
            }
            if (opt.index == '2') {
              aLink.setAttribute('download', '被驳回' + '.xlsx') // 设置下载文件名称
            }

            // aLink.setAttribute("download", "采买供需" + ".xlsx"); // 设置下载文件名称
            aLink.click()
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink)

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },
  // 设置显示与否的接口， https://api.cmef.com.cn/api/Release/SetIsShow?releaseId=d420ce6e-c1f5-441f-a883-b18aa9aa3d16&isShow=false
  newRealeaseSetIsShow({ rootState }, opt) {
    // 修改活动信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/NewRealease`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  // 活动设置
  PCActivityAdd({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/PCActivity`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  PCActivityPage({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/PCActivity/page`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  PCActivityPut({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/PCActivity`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  PCActivityGet({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/PCActivity?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  PCActivityRegLogPage({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/PCActivityRegLog/page`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },
  PCActivityUpdateRegCount({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/PCActivity/UpdateRegCount`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    })
  },

  PCActivityRegLogExcelExportLog({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/PCActivityRegLog/ExcelExportLog`, opt, {
          responseType: 'arraybuffer',
          ...rootState.header
        })
        .then((data) => {
          if (data.data) {
            // const aLink = document.createElement("a");
            // let blob = new Blob([data.data], {
            //     type: "application/vnd.ms-excel"
            // });
            // aLink.href = URL.createObjectURL(blob);
            // aLink.setAttribute("download", "报名名单导出" + ".xlsx"); // 设置下载文件名称
            // aLink.click();
            // this.$refs.loadElement.appendChild(aLink);

            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  },

  delPCActivity({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/PCActivity?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    })
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
